export default {
  title: "Addresses",

  input: {
    title: "{{action}} address",

    type: {
      label: "Address type",
    },
    address: {
      label: "Address",
    },
    street: {
      label: "Street",
    },
    streetNumber: {
      label: "Street number",
    },
    streetNumberAddition: {
      label: "Addition",
      placeholder: "Street number addition",
    },
    postalCode: {
      label: "Postal code",
    },
    city: {
      label: "City",
      warning: {
        needCountry: "First select a country",
      },
    },
    country: {
      label: "Country",
    },
  },

  view: {
    noItems: {
      title: "No address",
      text: "Click to add an address",
    },
    address: "Address: ",
    street: "Street: ",
  },
}
